import { Map } from "immutable";

export type Typography =
  | "XLargeTitle1"
  | "XLargeTitle2"
  | "LargeTitle1"
  | "LargeTitle2"
  | "H1"
  | "H2"
  | "H3"
  | "H4"
  | "Headline"
  | "Subhead1"
  | "Subhead2"
  | "Body1"
  | "Body1Medium"
  | "Body1SemiBold"
  | "Body1Bold"
  | "Body2"
  | "Body2Medium"
  | "Body2SemiBold"
  | "Body2Bold"
  | "Body2Underline"
  | "Caption"
  | "CaptionBold"
  | "InputXXLarge"
  | "InputXLarge"
  | "InputLarge"
  | "InputMedium"
  | "InputSmall"
  | "InputXSmall";

export const typography = Map<Typography, string>({
  XLargeTitle1: `
    font-size: 4.8rem;
    line-height: 5.6rem;
    font-weight: 700;    
  `,
  XLargeTitle2: `
    font-size: 4.0rem;
    line-height: 4.8rem;
    font-weight: 700;    
  `,
  LargeTitle1: `
    font-size: 3.2rem;
    line-height: 4.0rem;
    font-weight: 700;    
  `,
  LargeTitle2: `
    font-size: 2.8rem;
    line-height: 3.6rem;
    font-weight: 700;    
  `,
  H1: `
    font-size: 2.4rem;
    line-height: 3.2rem;
    font-weight: 700;    
  `,
  H2: `
    font-size: 2.2rem;
    line-height: 3.0rem;
    font-weight: 700;    
  `,
  H3: `
    font-size: 2.0rem;
    line-height: 2.8rem;
    font-weight: 700;    
  `,
  H4: `
    font-size: 1.8rem;
    line-height: 2.6rem;
    font-weight: 700;    
  `,
  Headline: `
    font-size: 1.8rem;
    line-height: 2.6rem;
    font-weight: 500;    
  `,
  Subhead1: `
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-weight: 500;    
  `,
  Subhead2: `
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 500;    
  `,
  Body1: `
    font-size: 1.6rem;
    line-height: 2.4rem;
    letter-spacing: -0.02em;
    font-weight: 400;
  `,
  Body1Medium: `
    font-size: 1.6rem;
    line-height: 2.4rem;
    letter-spacing: -0.02em;
    font-weight: 500;
  `,
  Body1SemiBold: `
    font-size: 1.6rem;
    line-height: 2.4rem;
    letter-spacing: -0.02em;
    font-weight: 600;
  `,
  Body1Bold: `
    font-size: 1.6rem;
    line-height: 2.4rem;
    letter-spacing: -0.02em;
    font-weight: 700;    
  `,
  Body2: `
    font-size: 1.4rem;
    line-height: 2.2rem;
    letter-spacing: -0.02em;
    font-weight: 400;
  `,
  Body2Medium: `
    font-size: 1.4rem;
    line-height: 2.2rem;
    letter-spacing: -0.02em;
    font-weight: 500;
`,
  Body2SemiBold: `
    font-size: 1.4rem;
    line-height: 2.2rem;
    letter-spacing: -0.02em;
    font-weight: 600;
`,
  Body2Bold: `
    font-size: 1.4rem;
    line-height: 2.2rem;
    letter-spacing: -0.02em;
    font-weight: 700;
  `,
  Body2Underline: `
    font-size: 1.4rem;
    line-height: 2.2rem;
    letter-spacing: -0.02em;
    font-weight: 400;
    text-decoration: underline;
  `,
  Caption: `
    font-size: 1.2rem;
    line-height: 1.8rem;
    letter-spacing: -0.01em;
    font-weight: 400;
  `,
  CaptionBold: `
    font-size: 1.2rem;
    line-height: 1.8rem;
    letter-spacing: -0.01em;
    font-weight: 600;
  `,
  InputXXLarge: `
    font-size: 3.2rem;
    line-height: 4.0rem;
    font-weight: 700;    
  `,
  InputXLarge: `
    font-size: 2.8rem;
    line-height: 3.6rem;
    font-weight: 700;    
  `,
  InputLarge: `
    font-size: 1.7rem;
    line-height: 2.5rem;
    font-weight: 500;    
  `,
  InputMedium: `
    font-size: 1.5rem;
    line-height: 2.3rem;
    font-weight: 500;    
  `,
  InputSmall: `
    font-size: 1.3rem;
    line-height: 2.1rem;
    font-weight: 500;    
  `,
  InputXSmall: `
    font-size: 1.0rem;
    line-height: 1.8rem;
    font-weight: 500;    
  `,
});
